import { Linking } from 'react-native';

import { Box, HStack, VStack } from '@fhs-legacy/universal-components';
import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { focusableLabeledA11yProps } from 'utils/accessibility/focusable-labeled-props';
import { getDirectionsAppUri } from 'utils/native-actions';

export const Container = HStack.withConfig({
  height: '74px',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: Styles.color.white,
  borderRadius: '10px',
  paddingX: '$5',
  paddingY: '$3.5',
  flex: 1,
});

type Props = {
  latitude: number;
  longitude: number;
  address: string | null;
  city: string | null;
  state: string | null;
};

export function StoreCard(props: Props) {
  const cityState = [props.city, props.state].filter(Boolean).join(', ');
  const addressAnnouncement = [props.address, cityState].filter(Boolean).join(', ');

  const addressBlock = (
    <VStack importantForAccessibility="no-hide-descendants">
      <Box>{props.address}</Box>
      <Box>{cityState}</Box>
    </VStack>
  );

  return (
    <Container>
      {addressAnnouncement ? (
        <Box {...focusableLabeledA11yProps(addressAnnouncement)}>{addressBlock}</Box>
      ) : (
        addressBlock
      )}
      <HStack>
        <ActionButton
          size={ActionButtonSizes.SMALL}
          variant={ActionButtonVariants.OUTLINE}
          onPress={() => {
            const uri = getDirectionsAppUri(props.latitude, props.longitude);
            if (uri) {
              Linking.openURL(uri);
            }
          }}
        >
          Directions
        </ActionButton>
      </HStack>
    </Container>
  );
}
